import { SignupActions, ErrorActions } from 'common/constants/actions';

const initialState = {
  step: { id: 1, page: 'Home' },
  data: [],
  department: [],
  team: [],
  employee: [],
  pending: false,
};

export default function signupStepsReducer(state = initialState, action) {
  switch (action.type) {
    case SignupActions.HOME:
      return {
        ...state,
        status: action.payload,
        errors: action.payload,
        showError: action.payload,
      };

    case SignupActions.DEPARTMENT:
      return {
        ...state,
        step: { id: 2, page: 'Department' },
        data: action.payload,
        department: action.payload,
        pending: false,
      };

    case SignupActions.TEAM:
      return {
        ...state,
        step: { id: 4, page: 'Team' },
        data: action.payload,
        team: action.payload,
        pending: false,
      };

    case SignupActions.EMPLOYEE:
      return {
        ...state,
        step: { id: 6, page: 'Employee' },
        data: action.payload,
        employee: action.payload,
        pending: false,
      };

    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        id: [],
        data: [],
        page: [],
        pending: false,
      };
    default:
      return state;
  }
}
